import React, { useState, useEffect } from 'react';
import Modal                          from 'react-bootstrap/Modal';
import CloseBtn                       from 'assets/icons/Close.svg';
import EmployeeBenefitsService        from 'services/employee-benefits.service';
import AuthService                    from 'services/auth.service';
import queryString                    from 'query-string';
import RedCheck                       from 'assets/icons/Red Check.svg';
import GreenTick                      from 'assets/icons/Green Tick.svg';
import { formatCurrency, nricOrPassport, standardDate } from 'helpers/common.helper';

export function WalkInModal(props) {
  const [show, setShow]                   = useState(false);
  const handleShow                        = () => setShow(true);
  const [sectionOne, setSectionOne]       = useState(true);
  const [sectionTwo, setSectionTwo]       = useState(false);
  const [sectionThree, setSectionThree]   = useState(false);
  const [sectionFive, setSectionFive]     = useState(false);
  const [displayFive, setDisplayFive]     = useState(<div></div>);
  const [errorIcon, setErrorIcon]         = useState(RedCheck);
  const [errorMsg, setErrorMsg]           = useState('This patient is not entitled for employee benefit.');
  const [errorHeader, setErrorHeader]     = useState('No ID Found');
  const practiceLocation                  = AuthService.getPracticeLocation();

  const handleClose = () => {
    setShow(false);
    setSectionOne(true);
    setSectionTwo(false);
    setSectionThree(false);
    setSectionFive(false);
    setErrorIcon(RedCheck);
    setErrorMsg('This patient is not entitled for employee benefit.');
    setErrorHeader('No ID Found');
    setNricField('');
    setClaimantId('');
    setEntitlementId('');
    setPolicyOwner('');
  };

  // Trigger refresh claims of parents after successful submission
    const refreshClaims = () => props.handleReload();

  // Function to select entitlement and display select locations
    const [patientInfo, setPatientInfo]     = useState([]);
    const [entitlementId, setEntitlementId] = useState('');
    const [entitlements, setEntitlements]   = useState([]);
    const [optical, setOptical]             = useState(false);

    const selectEntitlement = (hash, data) => {
      setPatientInfo([
        { title: 'Policy Owner',        value: data.personal_info.policy_owner },
        { title: 'NRIC/Passport No.',   value: nricOrPassport(data.personal_info.nric) },
        { title: 'Membership No.',      value: data.personal_info.membership_no },
        { title: 'Effective Date',      value: standardDate(data.personal_info.effective_date) },
        { title: 'Company Name',        value: data.personal_info.company_name },
        { title: 'Employee\'s ID',      value: data.personal_info.corporate_employee_id },
        { title: 'Visit Limit',         value: 'MYR ' + formatCurrency(hash.claim_limit) },
        { title: 'Practice Location',   value: practiceLocation.name },
        { title: 'Balance',             value: 'MYR ' + formatCurrency(hash.balance) },
        { title: 'Entitlement',         value: hash.name },
        { title: 'View Exclusion List', value: hash.policy_link }
      ]);

      setSectionThree(false);
      setSectionFive(true);
      setEntitlementId(hash.id);
      setOptical(hash.specialty_names.includes('Optometrist'));
    };

  // Submitting NRIC to API to retrieve entitlements
    const [nricField, setNricField]     = useState('');
    const [claimantId, setClaimantId]   = useState('');
    const [policyOwner, setPolicyOwner] = useState('');

    const nricNextClick = () => {
      const cleanedNric = nricField.replace(/-/g, '');
      let parameters;
      parameters = queryString.stringify({ nric: cleanedNric });

      // Submit nric & retrieve entitlement
        EmployeeBenefitsService.walkIn(parameters).then(
          (data) => {
            if (data.entitlements.length > 1) {
              const entitlementsButtons = data.entitlements.map((hash, index) => {
                return (
                  <div key={ index }>
                    <button className="select-entitlement-btn btn btn-outline-grey text-dark rounded-pill py-2 px-6 mb-4 w-em-45" onClick={() => { selectEntitlement(hash, data) }}>
                      <div className="d-flex align-items-center justify-content-between">
                        <span className="font-size-8">{ hash.name }</span>

                        <span className="text-right">
                          <p className="mb-0">Balance</p>
                          <p className="fweight-500 mb-0 font-size-7">{ 'MYR ' + formatCurrency(hash.balance) }</p>
                        </span>
                      </div>
                    </button>
                  </div>
                )
              });

              setEntitlements(entitlementsButtons);
              setSectionThree(true);
            } else if (data.entitlements.length === 1) {
              selectEntitlement(data.entitlements[0], data);
            }

            setPolicyOwner(data.personal_info.policy_owner);
            setClaimantId(data.claimant_id);
            setSectionOne(false);
          },
          (error) => {
            if (error.response.status === 401) {
              AuthService.logout();
              window.location.replace('/eb/login');
            }

            if (error.response.data.error === 'No ID found or not entitled') {
              setSectionOne(false);
              setSectionTwo(true);
            } else if (error.response.data.error === 'Doctor specialties not matched with employee entitlements') {
              setErrorMsg('This patient does not have any entitlements here.');
              setErrorHeader('No Entitlements');
              setSectionOne(false);
              setSectionTwo(true);
            }
          }
        );
    }

  // Reload all information for submitting after each section
    useEffect(() => {
      var infoList = patientInfo;
      if (infoList.length === 0) { return }

      const byChunks = infoList.reduce((memo, value, index) => {
        if (index % 2 === 0 && index !== 0) memo.push([])
        memo[memo.length - 1].push(value)
        return memo
      }, [[]]);

      const informationRows = byChunks.map((array, index) => {
        let rowDisplay;

        if (array[0]?.title === 'View Exclusion List') {
          if (array[0]?.value !== null) {
            rowDisplay = <div className="row" key={ index }>
              <div className="col text-left">
                <a className="text-danger" href={ array[0]?.value } target="_blank" rel="noreferrer">View Exclusion List</a>
              </div>
            </div>
          }
        } else {
          rowDisplay = <div className="row" key={ index }>
            <div className="col">
              <p className="text-left text-lightgrey mb-0">{ array[0]?.title }</p>
              <p className="text-left"><b>{ array[0]?.value || '-'  }</b></p>
            </div>

            <div className="col">
              <p className="text-left text-lightgrey mb-0">{ array[1]?.title }</p>
              <p className="text-left"><b>{ array[1] ? (array[1]?.value || '-') : null }</b></p>
            </div>
          </div>
        }

        return rowDisplay;
      });

      const handleSubmit = () => {
        // From rails side, for now, if it is Optometrist, we set 4, otherwise 0.
        // enum category: { general: 0, gp: 1, specialist: 2, dental: 3, optical: 4, ehs: 5 }

        const parameters = {
          visit: {
            claimant_id: claimantId,
            practice_location_id: practiceLocation.id,
            entitlement_id: entitlementId,
            category: optical ? 4 : 0
          }
        };

        EmployeeBenefitsService.createWalkIn(parameters).then(
          (data) => {
            setErrorIcon(GreenTick);
            setErrorHeader('Employee registered');
            setErrorMsg('A new claim has been opened for this visit.');
            setSectionFive(false);
            setSectionTwo(true);
            setTimeout(refreshClaims, 2000);
          },
          (error) => {
            if (error.response.status === 401) {
              AuthService.logout();
              window.location.replace('/eb/login');
            }

            if (error.response.data.errors && error.response.data.errors[0] === "Validation failed: Date Can't register for more than one visit per day") {
              setErrorHeader('Error');
              setErrorMsg("Can't register for more than one visit per day");
              setSectionFive(false);
              setSectionTwo(true);
            }
          }
        );
      }

      setDisplayFive(
        <div>
          { informationRows }
          <br/><br/>
          <button className="btn btn-danger rounded-pill py-3 px-5" onClick={() => { handleSubmit() }}>Confirm</button>
        </div>
      );
    }, [patientInfo, claimantId, entitlementId, optical]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <button className="btn btn-danger rounded-pill py-3 px-5 float-right" onClick={ handleShow }>Create Walk-In Visit</button>

      <Modal show={ show } onHide={ handleClose } keyboard={ false } size="lg" centered>
        <Modal.Header className="d-block">
          <h3 className="text-center conditional-display" displayed={ (sectionOne || sectionThree).toString() }>Walk-In Visit Registration</h3>
          <h3 className="conditional-display" displayed={ sectionFive.toString() }>Walk-In Visit Registration</h3>

          <button type="button" className="close" onClick={ handleClose }>
            <img src={ CloseBtn } alt="modal-close" />
          </button>
        </Modal.Header>

        <Modal.Body className="d-block text-center">
          <div className="conditional-display" displayed={ sectionOne.toString() }>
            <p className="text-center text-grey mb-10">Enter patient NRIC or passport no. to proceed.</p>

            <div className="d-flex justify-content-center mb-4">
              <input id="nric" name="nric" type="text"
                value={ nricField }
                onChange={(e) => setNricField(e.target.value) }
                className="form-control py-6 px-4 rounded-pill w-em-45 text-center"
              />
            </div>

            <button id="submit-check-btn" className="btn btn-danger text-white rounded-pill mt-10 py-3 px-20" disabled={ !nricField } onClick={ nricNextClick } >
              Next
            </button>
          </div>

          <div className="conditional-display" displayed={ sectionTwo.toString() }>
            <img src={ errorIcon } alt="error-check" />
            <h3 className="text-center text-danger my-6">{ errorHeader }</h3>

            <p className="text-center text-grey mb-10">{ errorMsg }</p>

            <button className="btn btn-danger text-white rounded-pill py-3 px-20" onClick={ handleClose } >
              OKAY
            </button>
          </div>

          <div className="conditional-display" displayed={ sectionThree.toString() }>
            <p className="text-primary font-size-7"><b>{ policyOwner }</b></p>
            <p className="text-center text-grey mb-10">Select an entitlement benefit to proceed.</p>
            { entitlements }
          </div>

          <div className="conditional-display" displayed={ sectionFive.toString() }>
            { displayFive }
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}